/**
 * Shared React Query client instance
 */
import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient();
